import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import axios from "axios";
import Swal from "sweetalert2";
import { Button, Table, Input, Badge } from "reactstrap";
import ExistenciasMeli from "./ExistenciasMeli";
import CambiosMeli from "./CambiosMeli";
import FullMeli from "./FullMeli";
import PanelMeli from "./PanelMeli";
import SinAltaMeli from "./SinAltaMeli";
import VentasPendientesMeli from "./VentasPendientesMeli";
import "./Integraciones.css";

// Navegacion del modulo, agrupada por lo que se va a hacer
const GRUPOS = [
  { items: [["panel", "Panel", "fas fa-chart-pie"]] },
  { titulo: "Ventas", items: [["ventas", "Ventas Meli", "fas fa-receipt"], ["pendientes", "Ventas no capturadas", "fas fa-exclamation-circle"]] },
  { titulo: "Catalogo", items: [["publicaciones", "Publicaciones", "fas fa-tags"], ["sinAlta", "Sin alta en Cuory", "fas fa-box-open"]] },
  { titulo: "Inventario", items: [["existencias", "Existencias Meli", "fas fa-cubes"], ["full", "Full vs Cuory", "fas fa-warehouse"]] },
  { titulo: "Control", items: [["cambios", "Cambios en Meli", "fas fa-history"], ["bitacora", "Bitacora", "fas fa-list"], ["cuentas", "Cuentas", "fas fa-plug"]] },
];

// Integraciones con marketplaces. Cada cuenta arranca en "Apagado": aunque
// tenga credenciales y este autorizada, no lee ni escribe en el canal hasta
// que alguien la prenda aqui.
function Integraciones() {
  const { user } = useContext(AuthContext);
  const URL = process.env.REACT_APP_URL_MARKETPLACE;
  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  const [cuentas, setCuentas] = useState([]);
  const [areas, setAreas] = useState([]);
  const [pestana, setPestana] = useState("panel");
  const [resumenPanel, setResumenPanel] = useState(null);
  const [bitacora, setBitacora] = useState([]);
  const [publicaciones, setPublicaciones] = useState([]);
  const [soloSinCasar, setSoloSinCasar] = useState(true);
  const [trabajando, setTrabajando] = useState("");
  const [habilitado, setHabilitado] = useState(false);
  // Ventas por cortes (Mercado Libre)
  const [clientes, setClientes] = useState([]);
  const [ventas, setVentas] = useState([]);
  const [filtroCuenta, setFiltroCuenta] = useState("");
  const [filtroEstado, setFiltroEstado] = useState("");
  // Filtros de publicaciones
  const [pubCuenta, setPubCuenta] = useState("");
  const [pubLogistica, setPubLogistica] = useState("");
  const [pubBusca, setPubBusca] = useState("");
  const [pubPagina, setPubPagina] = useState(0);
  const [pubTrabajando, setPubTrabajando] = useState("");

  function cargaCuentas() {
    axios
      .get(`${URL}Cuentas`, { headers })
      .then((res) => setCuentas(res.data || []))
      .catch((err) => console.log(err));
  }

  useEffect(() => {
    cargaCuentas();
    axios
      .get(`${URL}Estado`, { headers })
      .then((res) => setHabilitado(!!res.data?.habilitado))
      .catch(() => setHabilitado(false));
    axios
      .get(process.env.REACT_APP_URL_AREAS, { headers })
      .then((res) => setAreas((res.data || []).filter((a) => a.is_active === "Si")))
      .catch(() => setAreas([]));
    axios
      .get(process.env.REACT_APP_URL_CLIENTES, { headers })
      .then((res) =>
        setClientes(
          (res.data || [])
            .filter((c) => c.is_active === "Si")
            .sort((a, b) => ((a.nombre_comercial || "") > (b.nombre_comercial || "") ? 1 : -1))
        )
      )
      .catch(() => setClientes([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (pestana === "bitacora") {
      axios
        .get(`${URL}Bitacora`, { headers })
        .then((res) => setBitacora(res.data || []))
        .catch(() => setBitacora([]));
    }
    if (pestana === "ventas") cargaVentas();
    if (pestana === "publicaciones") cargaPublicaciones();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pestana, soloSinCasar, filtroCuenta, filtroEstado, pubCuenta, pubLogistica]);

  function cargaPublicaciones() {
    const p = new URLSearchParams();
    if (soloSinCasar) p.set("sinCasar", "Si");
    if (pubCuenta) p.set("cuenta", pubCuenta);
    if (pubLogistica) p.set("logistica", pubLogistica);
    if (pubBusca.trim()) p.set("q", pubBusca.trim());
    axios
      .get(`${URL}Publicaciones?${p.toString()}`, { headers })
      .then((res) => {
        setPublicaciones(res.data || []);
        setPubPagina(0);
      })
      .catch(() => setPublicaciones([]));
  }

  // Reemplaza el renglon con lo que regreso el servidor
  const actualizaPub = (pub) => setPublicaciones((lista) => lista.map((x) => (x._id === pub._id ? pub : x)));

  function amarra(p) {
    Swal.fire({
      title: "Amarrar con un articulo de Cuory",
      html: `<div style="font-size:13px;text-align:left">${p.titulo}${p.variacion ? `<br><span style="color:#64748b">${p.variacion}</span>` : ""}</div>`,
      input: "text",
      inputValue: p.articulos?.[0]?.SKU || "",
      inputPlaceholder: "SKU de Cuory (vacio = quitar amarre)",
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
    }).then((r) => {
      if (!r.isConfirmed) return;
      const sku = String(r.value || "").trim();
      axios
        .patch(`${URL}Publicaciones/${p._id}`, sku ? { sku } : { articulos: "" }, { headers })
        .then((res) => {
          actualizaPub(res.data);
          // Si la publicacion no trae el SKU, ofrece escribirlo en Meli para que las ventas casen solas
          if (sku && res.data.skuCanal !== sku && p.cuentas?.[0]?.modo === "Lectura y escritura") {
            Swal.fire({
              title: "Escribir el SKU en Mercado Libre?",
              text: `La publicacion tiene SKU "${res.data.skuCanal || "vacio"}". Si le pones ${sku}, las ventas casan solas aunque se vuelva a leer.`,
              icon: "question",
              showCancelButton: true,
              confirmButtonText: "Si, escribirlo",
              cancelButtonText: "No",
            }).then((x) => x.isConfirmed && cambiaEnMeli(res.data, "SKU", sku));
          }
        })
        .catch((e) => error(e, "No se pudo amarrar"));
    });
  }

  function cambiaEnMeli(p, tipo, valor) {
    setPubTrabajando(p._id);
    axios
      .post(`${URL}PublicacionCambio/${p._id}`, { tipo, valor }, { headers })
      .then((res) => {
        setPubTrabajando("");
        if (tipo === "Estado") cargaPublicaciones();
        else if (res.data.publicacion) actualizaPub(res.data.publicacion);
        Swal.fire({
          icon: "success",
          title: res.data.sinCambio ? "Ya estaba asi" : "Cambiado en Mercado Libre",
          timer: 1400,
          showConfirmButton: false,
        });
      })
      .catch((e) => {
        setPubTrabajando("");
        error(e, "Mercado Libre no acepto el cambio");
      });
  }

  function pidePrecio(p) {
    Swal.fire({
      title: "Precio en Mercado Libre",
      html: `<div style="font-size:13px;text-align:left">${p.titulo}${p.variacion ? `<br><span style="color:#64748b">${p.variacion}</span>` : ""}<br>Hoy: <b>$${Number(p.precio).toLocaleString("en-US")}</b></div>`,
      input: "number",
      inputValue: p.precio,
      inputAttributes: { min: 1, step: "0.01" },
      showCancelButton: true,
      confirmButtonText: "Cambiar",
      cancelButtonText: "Cancelar",
      inputValidator: (v) => (!(Number(v) > 0) ? "Precio no valido" : null),
    }).then((r) => r.isConfirmed && Number(r.value) !== Number(p.precio) && cambiaEnMeli(p, "Precio", Number(r.value)));
  }

  function pideStock(p) {
    Swal.fire({
      title: "Stock de bodega propia",
      html: `<div style="font-size:13px;text-align:left">${p.titulo}${p.variacion ? `<br><span style="color:#64748b">${p.variacion}</span>` : ""}<br>Ultima lectura: <b>${p.stockCanal}</b></div>`,
      input: "number",
      inputValue: p.stockCanal,
      inputAttributes: { min: 0, step: "1" },
      showCancelButton: true,
      confirmButtonText: "Poner",
      cancelButtonText: "Cancelar",
      inputValidator: (v) => (v === "" || Number(v) < 0 ? "Cantidad no valida" : null),
    }).then((r) => r.isConfirmed && cambiaEnMeli(p, "Stock", Number(r.value)));
  }

  function pausaActiva(p) {
    const nuevo = p.estadoPublicacion === "active" ? "paused" : "active";
    Swal.fire({
      title: nuevo === "paused" ? "Pausar publicacion" : "Activar publicacion",
      text: `${p.idPublicacion} · ${p.titulo}${p.idVariacion ? " (aplica a todas sus variaciones)" : ""}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: nuevo === "paused" ? "Pausar" : "Activar",
      cancelButtonText: "Cancelar",
    }).then((r) => r.isConfirmed && cambiaEnMeli(p, "Estado", nuevo));
  }

  function cargaVentas() {
    const p = new URLSearchParams();
    if (filtroCuenta) p.set("cuenta", filtroCuenta);
    if (filtroEstado) p.set("estado", filtroEstado);
    axios
      .get(`${URL}Ventas?${p.toString()}`, { headers })
      .then((res) => setVentas(res.data || []))
      .catch(() => setVentas([]));
  }

  // Guarda un dato de la configuracion de ventas de la cuenta
  function guardaVentas(c, cambios) {
    axios
      .patch(`${URL}Cuentas/${c._id}`, cambios, { headers })
      .then(() => cargaCuentas())
      .catch((e) => error(e, "No se pudo guardar"));
  }

  function cambiaRegistrar(c, valor) {
    if (valor === "Si" && !c.clientes) {
      Swal.fire({ icon: "warning", title: "Primero elige el cliente al que se cargan las ventas" });
      return;
    }
    Swal.fire({
      title: valor === "Si" ? `Registrar ventas de ${c.nombre}` : `Dejar de registrar ventas de ${c.nombre}`,
      html:
        valor === "Si"
          ? `<div style="text-align:left;font-size:14px"><b>Cada 3 horas</b> se jalan las ordenes que cambiaron y:
             <ul><li>las ventas <b>Full</b> entran a <b>un surtido</b> por corte (descuenta inventario aunque quede negativo)</li>
             <li>las ventas <b>Drop</b> entran a <b>un pedido</b> por corte, pendiente de surtir</li>
             <li>las <b>cancelaciones</b> se quitan del pedido y, si ya se surtio, de la nota</li>
             <li>las <b>devoluciones</b> del comprador entran a una devolucion</li></ul>
             La cuenta debe estar prendida (modo Lectura).</div>`
          : "Los cortes dejan de registrar ventas de esta cuenta.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "Cancelar",
    }).then((r) => r.isConfirmed && guardaVentas(c, { registrarVentas: valor }));
  }

  function corte(c, simular) {
    const correr = () => {
      setTrabajando(c._id);
      axios
        .post(`${URL}Corte/${c._id}`, { simular: simular ? "Si" : "No" }, { headers })
        .then((res) => {
          setTrabajando("");
          cargaCuentas();
          const d = res.data || {};
          Swal.fire({
            icon: "success",
            title: simular ? "Simulacion (no se guardo nada)" : "Corte hecho",
            html: `<div style="text-align:left;font-size:14px">
              ${d.ordenes} ordenes con cambios<br>
              <b>${d.nuevas} ventas nuevas</b> (${d.piezas} pzs, $${Number(d.importe || 0).toLocaleString("en-US")})
              ${d.surtido ? ` · Full en surtido ${d.surtido}` : ""}${d.pedidoDrop ? ` · Drop en pedido ${d.pedidoDrop}` : ""}<br>
              ${d.canceladas || 0} canceladas · ${d.devueltas || 0} devueltas${d.devolucion ? ` · devolucion ${d.devolucion}` : ""}<br>
              ${d.sinCasar ? `<span style="color:#b45309">${d.sinCasar} sin casar (no hay articulo con ese SKU)</span><br>` : ""}
              ${d.errores ? `<span style="color:#b91c1c">${d.errores} con error</span>` : ""}
            </div>`,
          });
        })
        .catch((e) => {
          setTrabajando("");
          cargaCuentas();
          error(e, simular ? "No se pudo simular" : "No se pudo hacer el corte");
        });
    };
    if (simular) return correr();
    Swal.fire({
      title: `Correr corte de ${c.nombre} ahora`,
      text: "Registra las ventas pagadas desde el ultimo corte: Full en un surtido, Drop en un pedido pendiente de surtir (y aplica cancelaciones y devoluciones).",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Correr",
      cancelButtonText: "Cancelar",
    }).then((r) => r.isConfirmed && correr());
  }

  function error(e, titulo) {
    Swal.fire({
      icon: "error",
      title: titulo,
      text: e.response?.data?.message || e.message,
    });
  }

  function prueba(c) {
    setTrabajando(c._id);
    axios
      .get(`${URL}Prueba/${c._id}`, { headers })
      .then((res) => {
        setTrabajando("");
        cargaCuentas();
        Swal.fire({
          icon: "success",
          title: "Conexion viva",
          text: `${res.data.nickname} · vendedor ${res.data.sellerId} · ${res.data.sitio}`,
        });
      })
      .catch((e) => {
        setTrabajando("");
        cargaCuentas();
        error(e, "La conexion no responde");
      });
  }

  function cambiaModo(c, modo) {
    if (modo === c.modo) return;
    const textos = {
      Apagado: "No va a leer ni escribir nada en el canal.",
      Lectura: "Mantiene viva la conexion y, si \"Registrar ventas\" esta en Si, registra las ventas en los cortes de cada 3 horas. No escribe nada en Mercado Libre.",
      "Lectura y escritura":
        "Ademas de leer, permite escribir en Mercado Libre: existencias de bodega propia (pestana Existencias Meli), precio, pausar/activar y SKU (pestana Publicaciones). Todo queda en \"Cambios en Meli\" y se puede revertir.",
    };
    Swal.fire({
      title: `${c.nombre}: ${modo}`,
      text: textos[modo],
      icon: modo === "Apagado" ? "info" : "warning",
      showCancelButton: true,
      confirmButtonText: "Si, cambiar",
      cancelButtonText: "Cancelar",
    }).then((r) => {
      if (!r.isConfirmed) return;
      axios
        .patch(`${URL}Cuentas/${c._id}`, { modo }, { headers })
        .then(() => cargaCuentas())
        .catch((e) => error(e, "No se pudo cambiar el modo"));
    });
  }

  function cambiaArea(c, area) {
    axios
      .patch(`${URL}Cuentas/${c._id}`, { areas: area }, { headers })
      .then(() => cargaCuentas())
      .catch((e) => error(e, "No se pudo guardar el almacen"));
  }

  function sincroniza(c) {
    Swal.fire({
      title: `Leer publicaciones de ${c.nombre}`,
      text: "Lee todas las publicaciones y las amarra al catalogo por SKU, ASIN o EAN. No escribe nada en el canal.",
      showCancelButton: true,
      confirmButtonText: "Leer",
      cancelButtonText: "Cancelar",
    }).then((r) => {
      if (!r.isConfirmed) return;
      setTrabajando(c._id);
      axios
        .post(
          `${URL}SincronizaPublicaciones/${c._id}`,
          {},
          { headers }
        )
        .then((res) => {
          setTrabajando("");
          cargaCuentas();
          const d = res.data;
          Swal.fire({
            icon: "success",
            title: `${d.porcentajeCasado}% amarrado`,
            html: `${d.publicacionesCanal ? `${d.publicacionesCanal} publicaciones · ` : ""}${d.publicaciones} renglones (por variacion)<br>
              ${d.casadasPorSKU} por SKU · ${d.casadasPorEAN} por EAN<br>
              <b>${d.sinCasar} sin amarrar</b>`,
          });
        })
        .catch((e) => {
          setTrabajando("");
          error(e, "No se pudieron leer las publicaciones");
        });
    });
  }

  function agregaAmazon() {
    Swal.fire({
      title: "Agregar cuenta de Amazon",
      html: `<div style="text-align:left;font-size:13px">
        <p style="color:#64748b">Estos datos salen de la aplicacion privada en Seller Central
        (Apps and Services &rarr; Develop Apps) despues de autorizarla a su propia cuenta.</p>
        <input id="az-nombre" class="swal2-input" placeholder="Nombre de la cuenta" style="width:88%">
        <input id="az-client" class="swal2-input" placeholder="LWA Client ID" style="width:88%">
        <input id="az-secret" class="swal2-input" placeholder="LWA Client Secret" type="password" style="width:88%">
        <input id="az-refresh" class="swal2-input" placeholder="Refresh Token" type="password" style="width:88%">
        <input id="az-seller" class="swal2-input" placeholder="Seller ID (Merchant Token)" style="width:88%">
      </div>`,
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
      focusConfirm: false,
      preConfirm: () => {
        const v = (id) => (document.getElementById(id).value || "").trim();
        const datos = {
          plataforma: "Amazon",
          nombre: v("az-nombre"),
          appId: v("az-client"),
          clientSecret: v("az-secret"),
          refreshToken: v("az-refresh"),
          sellerId: v("az-seller"),
        };
        if (!datos.nombre || !datos.appId || !datos.clientSecret || !datos.refreshToken) {
          Swal.showValidationMessage("Nombre, Client ID, Client Secret y Refresh Token son obligatorios");
          return false;
        }
        return datos;
      },
    }).then((r) => {
      if (!r.isConfirmed) return;
      axios
        .post(`${URL}Cuentas`, r.value, { headers })
        .then(() => {
          cargaCuentas();
          Swal.fire({ icon: "success", title: "Cuenta guardada", text: "Queda en modo Apagado." });
        })
        .catch((e) => error(e, "No se pudo guardar la cuenta"));
    });
  }

  const colorEstado = { Conectada: "success", Error: "danger", "Sin conectar": "secondary" };
  const colorModo = { Apagado: "secondary", Lectura: "info", "Lectura y escritura": "warning" };

  if (!user.configuracion) {
    return (
      <>
        <Header />
        <div className="card" style={{ margin: 20, padding: 20 }}>
          No tienes permiso para ver las integraciones.
        </div>
      </>
    );
  }

  return (
    <>
      <Header />
      <br />
      <div className="intg">
        <div className="intg-marco">
          <div className="intg-encabezado">
            <div>
              <h3>Integraciones</h3>
              <p>Ventas, cancelaciones e inventario con Mercado Libre</p>
            </div>
            <span className={`intg-pill ${habilitado ? "ok" : "alerta"}`}>
              <i className={habilitado ? "fas fa-circle" : "fas fa-pause-circle"} style={{ fontSize: 9 }}></i>
              {habilitado ? "Conexion activa" : "Modo preparativo"}
            </span>
          </div>
          {!habilitado ? (
            <div className="intg-aviso" style={{ fontSize: 13, padding: "8px 12px", marginBottom: 14 }}>
              <b>Modo preparativo.</b> Se pueden guardar credenciales, autorizar cuentas y probar la conexion,
              pero el sistema <b>no jala nada</b> de los canales hasta que se habilite en el servidor.
            </div>
          ) : null}

          <div className="intg-nav">
            {GRUPOS.map((g, n) => (
              <div className="intg-nav-grupo" key={n}>
                {g.titulo ? <span className="intg-nav-titulo">{g.titulo}</span> : null}
                {g.items.map(([k, l, icono]) => {
                  const cuenta = !resumenPanel
                    ? 0
                    : k === "pendientes"
                    ? resumenPanel.noCapturadas
                    : k === "sinAlta"
                    ? resumenPanel.sinAlta.porDarDeAlta
                    : 0;
                  return (
                    <button key={k} className={`intg-tab ${pestana === k ? "activa" : ""}`} onClick={() => setPestana(k)}>
                      <i className={icono}></i> {l}
                      {cuenta ? <span className="intg-cuenta-n">{cuenta}</span> : null}
                    </button>
                  );
                })}
              </div>
            ))}
          </div>

          {pestana === "panel" ? <PanelMeli URL={URL} headers={headers} irA={setPestana} alCargar={setResumenPanel} /> : null}

          {pestana === "sinAlta" ? <SinAltaMeli URL={URL} headers={headers} cuentas={cuentas} habilitado={habilitado} error={error} /> : null}

          {pestana === "pendientes" ? (
            <VentasPendientesMeli URL={URL} headers={headers} cuentas={cuentas} habilitado={habilitado} error={error} />
          ) : null}

          {pestana === "cuentas" ? (
            <div className="intg-barra" style={{ justifyContent: "space-between" }}>
              <span style={{ fontSize: 12, color: "#64748b" }}>
                Cada cuenta arranca <b>Apagada</b>: mientras este apagada no se lee ni se escribe nada en el canal.
              </span>
              <Button size="sm" color="warning" onClick={agregaAmazon}>
                <i class="fab fa-amazon"></i> Agregar cuenta de Amazon
              </Button>
            </div>
          ) : null}

          {pestana === "cuentas" ? (
            <Table size="sm" striped borderless className="table-responsive-xl">
              <thead>
                <tr>
                  <th>Plataforma</th>
                  <th>Cuenta</th>
                  <th>App ID</th>
                  <th>Estado</th>
                  <th>Vendedor</th>
                  <th>Almacen de ventas</th>
                  <th>Modo</th>
                  <th>Ultima lectura</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {cuentas.map((c) => (
                  <React.Fragment key={c._id}>
                  <tr>
                    <td>{c.plataforma}</td>
                    <td>
                      <b>{c.nombre}</b>
                    </td>
                    <td style={{ fontSize: 12, fontFamily: "monospace" }}>{c.appId}</td>
                    <td>
                      <Badge color={colorEstado[c.estado] || "secondary"} pill title={c.ultimoError}>
                        {c.estado}
                      </Badge>
                      {c.ultimoError ? (
                        <div style={{ fontSize: 10, color: "#b91c1c", maxWidth: 180 }}>{c.ultimoError}</div>
                      ) : null}
                    </td>
                    <td style={{ fontSize: 12 }}>
                      {c.nickname || c.sellerId || <span style={{ color: "#94a3b8" }}>sin autorizar</span>}
                    </td>
                    <td style={{ minWidth: 190 }}>
                      <Input
                        bsSize="sm"
                        type="select"
                        value={(c.areas && c.areas[0] && (c.areas[0]._id || c.areas[0])) || ""}
                        onChange={(e) => cambiaArea(c, e.target.value)}
                      >
                        <option value="">Sin asignar</option>
                        {areas.map((a) => (
                          <option key={a._id} value={a._id}>
                            {a.name}
                          </option>
                        ))}
                      </Input>
                    </td>
                    <td style={{ minWidth: 170 }}>
                      <Input
                        bsSize="sm"
                        type="select"
                        value={c.modo}
                        disabled={!habilitado}
                        title={habilitado ? "" : "Modo preparativo: no se puede prender"}
                        onChange={(e) => cambiaModo(c, e.target.value)}
                      >
                        <option value="Apagado">Apagado</option>
                        <option value="Lectura">Lectura</option>
                        <option value="Lectura y escritura">Lectura y escritura</option>
                      </Input>
                      <Badge color={colorModo[c.modo]} pill style={{ marginTop: 3 }}>
                        {c.modo}
                      </Badge>
                    </td>
                    <td style={{ fontSize: 11 }}>
                      {c.ultimaSyncPublicaciones
                        ? `Publ. ${String(c.ultimaSyncPublicaciones).slice(0, 10)}`
                        : "—"}
                      <br />
                      {c.ultimaSyncOrdenes ? `Ord. ${String(c.ultimaSyncOrdenes).slice(0, 16).replace("T", " ")}` : ""}
                    </td>
                    <td style={{ minWidth: 220 }}>
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 4 }}>
                        {c.plataforma === "Mercado Libre" ? (
                          // Deshabilitado: generar una liga nueva invalida la que ya se le mando al
                          // cliente. Las ligas las genera soporte.
                          <Button size="sm" color="primary" disabled title="Las ligas de autorizacion las genera soporte">
                            <i class="fas fa-key"></i> Autorizar
                          </Button>
                        ) : null}
                        <Button
                          size="sm"
                          color="info"
                          disabled={!c.conectada || trabajando === c._id}
                          title={c.conectada ? "Probar conexion" : "Primero hay que autorizar"}
                          onClick={() => prueba(c)}
                        >
                          <i class="fas fa-plug"></i>
                        </Button>
                        <Button
                          size="sm"
                          color="success"
                          disabled={!habilitado || c.modo === "Apagado" || !c.conectada || trabajando === c._id}
                          title={
                            !habilitado
                              ? "Modo preparativo: no se jala nada"
                              : c.modo === "Apagado"
                              ? "La cuenta esta apagada"
                              : c.conectada
                              ? "Leer publicaciones y armar el mapeo"
                              : "Primero hay que autorizar"
                          }
                          onClick={() => sincroniza(c)}
                        >
                          {trabajando === c._id ? "Leyendo..." : <i class="fas fa-sync"></i>}
                        </Button>
                      </div>
                    </td>
                  </tr>
                  {c.plataforma === "Mercado Libre" ? (
                    <tr>
                      <td></td>
                      <td colSpan={8} style={{ background: "#f8fafc", fontSize: 12 }}>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 10, alignItems: "flex-end" }}>
                          <div>
                            <div style={{ color: "#64748b" }}>Registrar ventas (cada 3 horas)</div>
                            <Input
                              bsSize="sm"
                              type="select"
                              value={c.registrarVentas || "No"}
                              onChange={(e) => cambiaRegistrar(c, e.target.value)}
                              style={{ width: 90 }}
                            >
                              <option value="No">No</option>
                              <option value="Si">Si</option>
                            </Input>
                          </div>
                          <div>
                            <div style={{ color: "#64748b" }}>Cliente de las ventas</div>
                            <Input
                              bsSize="sm"
                              type="select"
                              value={c.clientes || ""}
                              onChange={(e) => guardaVentas(c, { clientes: e.target.value })}
                              style={{ width: 210 }}
                            >
                              <option value="">Elige...</option>
                              {clientes.map((x) => (
                                <option key={x._id} value={x._id}>
                                  {x.nombre_comercial}
                                </option>
                              ))}
                            </Input>
                          </div>
                          <div title="Las ventas Full salen de este almacen. Si no se elige, salen del almacen de ventas">
                            <div style={{ color: "#64748b" }}>Almacen Full</div>
                            <Input
                              bsSize="sm"
                              type="select"
                              value={c.areaFull || ""}
                              onChange={(e) => guardaVentas(c, { areaFull: e.target.value })}
                              style={{ width: 200 }}
                            >
                              <option value="">El mismo de ventas</option>
                              {areas.map((a) => (
                                <option key={a._id} value={a._id}>
                                  {a.name}
                                </option>
                              ))}
                            </Input>
                          </div>
                          <div title="El primer corte toma las ordenes desde esta fecha">
                            <div style={{ color: "#64748b" }}>Primer corte desde</div>
                            <Input
                              bsSize="sm"
                              type="date"
                              value={c.fechaInicioVentas ? String(c.fechaInicioVentas).slice(0, 10) : ""}
                              onChange={(e) => guardaVentas(c, { fechaInicioVentas: e.target.value })}
                              style={{ width: 150 }}
                            />
                          </div>
                          <div style={{ display: "flex", gap: 4 }}>
                            <Button
                              size="sm"
                              color="secondary"
                              outline
                              disabled={!c.conectada || trabajando === c._id}
                              title={c.conectada ? "Ver que registraria el corte, sin guardar nada" : "Primero hay que autorizar"}
                              onClick={() => corte(c, true)}
                            >
                              <i class="fas fa-flask"></i> Simular
                            </Button>
                            <Button
                              size="sm"
                              color="success"
                              disabled={!habilitado || !c.conectada || !c.clientes || trabajando === c._id}
                              title={
                                !habilitado
                                  ? "Modo preparativo: no se jala nada"
                                  : !c.conectada
                                  ? "Primero hay que autorizar"
                                  : !c.clientes
                                  ? "Falta el cliente"
                                  : "Correr el corte ahora"
                              }
                              onClick={() => corte(c, false)}
                            >
                              <i class="fas fa-cash-register"></i> {trabajando === c._id ? "Trabajando..." : "Correr corte"}
                            </Button>
                          </div>
                          <div style={{ color: "#475569", flex: 1, minWidth: 220 }}>
                            <b>Ultimo corte:</b> {c.ultimoCorte || "todavia no hay"}
                          </div>
                        </div>
                      </td>
                    </tr>
                  ) : null}
                  </React.Fragment>
                ))}
              </tbody>
            </Table>
          ) : null}

          {pestana === "publicaciones" ? (
            <>
              <div style={{ display: "flex", gap: 10, marginBottom: 10, flexWrap: "wrap", alignItems: "center" }}>
                <Input bsSize="sm" type="select" value={pubCuenta} onChange={(e) => setPubCuenta(e.target.value)} style={{ width: 180 }}>
                  <option value="">Todas las cuentas</option>
                  {cuentas.map((c) => (
                    <option key={c._id} value={c._id}>
                      {c.nombre}
                    </option>
                  ))}
                </Input>
                <Input bsSize="sm" type="select" value={pubLogistica} onChange={(e) => setPubLogistica(e.target.value)} style={{ width: 170 }}>
                  <option value="">Full y bodega propia</option>
                  <option value="Propia">Solo bodega propia</option>
                  <option value="Full">Solo Full</option>
                </Input>
                <Input
                  bsSize="sm"
                  placeholder="Buscar titulo, SKU o publicacion (Enter)"
                  value={pubBusca}
                  onChange={(e) => setPubBusca(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && cargaPublicaciones()}
                  style={{ width: 280 }}
                />
                <label style={{ fontSize: 13, cursor: "pointer", marginBottom: 0 }}>
                  <input
                    type="checkbox"
                    checked={soloSinCasar}
                    onChange={(e) => setSoloSinCasar(e.currentTarget.checked)}
                    style={{ marginRight: 6 }}
                  />
                  Solo las que no se pudieron amarrar
                </label>
                <span style={{ fontSize: 12, color: "#64748b" }}>{publicaciones.length} renglones</span>
              </div>
              <Table size="sm" striped borderless className="table-responsive-xl">
                <thead>
                  <tr>
                    <th>Cuenta</th>
                    <th>Publicacion</th>
                    <th>Titulo</th>
                    <th>SKU en el canal</th>
                    <th className="text-right">Precio</th>
                    <th className="text-right">Stock</th>
                    <th>Estado</th>
                    <th>Articulo Cuory</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {publicaciones.slice(pubPagina * 100, pubPagina * 100 + 100).map((p) => {
                    const escribe = p.cuentas?.[0]?.modo === "Lectura y escritura" && p.cuentas?.[0]?.plataforma === "Mercado Libre";
                    const ocupado = pubTrabajando === p._id;
                    const full = p.logistica === "fulfillment";
                    return (
                      <tr key={p._id}>
                        <td>{p.cuentas?.[0]?.nombre}</td>
                        <td style={{ fontSize: 12 }}>
                          {p.permalink ? (
                            <a href={p.permalink} target="_blank" rel="noopener noreferrer">
                              {p.idPublicacion}
                            </a>
                          ) : (
                            p.idPublicacion
                          )}
                        </td>
                        <td style={{ fontSize: 12, maxWidth: 280 }}>
                          {p.titulo}
                          {p.variacion ? <div style={{ color: "#64748b" }}>{p.variacion}</div> : null}
                        </td>
                        <td style={{ fontSize: 12 }}>{p.skuCanal || <span style={{ color: "#94a3b8" }}>vacio</span>}</td>
                        <td className="text-right">${Number(p.precio || 0).toLocaleString("en-US")}</td>
                        <td className="text-right">
                          {p.stockCanal}
                          <div>
                            <Badge pill color={full ? "dark" : "light"} title={full ? "Stock en bodega de Mercado Libre" : "Stock de bodega propia"}>
                              {full ? "Full" : "Propia"}
                            </Badge>
                          </div>
                        </td>
                        <td>
                          <Badge pill color={p.estadoPublicacion === "active" ? "success" : p.estadoPublicacion === "paused" ? "secondary" : "danger"} title={p.subEstado}>
                            {p.estadoPublicacion === "active" ? "activa" : p.estadoPublicacion === "paused" ? "pausada" : p.estadoPublicacion}
                          </Badge>
                          {p.noSincronizar === "Si" ? <div style={{ fontSize: 10, color: "#64748b" }}>sin existencias</div> : null}
                        </td>
                        <td style={{ fontSize: 12 }}>
                          {p.articulos?.[0] ? `${p.articulos[0].SKU} · ${p.articulos[0].nombre}` : "—"}
                          <div>
                            <Badge color={p.casadoPor === "Sin casar" ? "warning" : "success"} pill>
                              {p.casadoPor}
                            </Badge>
                          </div>
                        </td>
                        <td style={{ minWidth: 190 }}>
                          <div style={{ display: "flex", flexWrap: "wrap", gap: 3 }}>
                            <Button size="sm" color="primary" outline title="Amarrar con un articulo de Cuory" onClick={() => amarra(p)}>
                              <i class="fas fa-link"></i>
                            </Button>
                            {escribe ? (
                              <>
                                <Button size="sm" color="info" outline disabled={ocupado} title="Cambiar precio en Meli" onClick={() => pidePrecio(p)}>
                                  <i class="fas fa-dollar-sign"></i>
                                </Button>
                                <Button
                                  size="sm"
                                  color="info"
                                  outline
                                  disabled={ocupado || full}
                                  title={full ? "Full: el stock lo maneja Mercado Libre" : "Poner stock de bodega propia en Meli"}
                                  onClick={() => pideStock(p)}
                                >
                                  <i class="fas fa-boxes"></i>
                                </Button>
                                {["active", "paused"].includes(p.estadoPublicacion) ? (
                                  <Button
                                    size="sm"
                                    color={p.estadoPublicacion === "active" ? "secondary" : "success"}
                                    outline
                                    disabled={ocupado}
                                    title={p.estadoPublicacion === "active" ? "Pausar en Meli" : "Activar en Meli"}
                                    onClick={() => pausaActiva(p)}
                                  >
                                    <i class={p.estadoPublicacion === "active" ? "fas fa-pause" : "fas fa-play"}></i>
                                  </Button>
                                ) : null}
                                {p.articulos?.[0] && p.skuCanal !== p.articulos[0].SKU ? (
                                  <Button
                                    size="sm"
                                    color="warning"
                                    outline
                                    disabled={ocupado}
                                    title={`Escribir ${p.articulos[0].SKU} como SKU en Meli`}
                                    onClick={() => cambiaEnMeli(p, "SKU", p.articulos[0].SKU)}
                                  >
                                    <i class="fas fa-barcode"></i>
                                  </Button>
                                ) : null}
                              </>
                            ) : null}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              {publicaciones.length > 100 ? (
                <div style={{ display: "flex", gap: 6, alignItems: "center", justifyContent: "center", fontSize: 13 }}>
                  <Button size="sm" color="secondary" disabled={pubPagina === 0} onClick={() => setPubPagina(pubPagina - 1)}>
                    Anterior
                  </Button>
                  Pagina {pubPagina + 1} de {Math.ceil(publicaciones.length / 100)}
                  <Button
                    size="sm"
                    color="secondary"
                    disabled={(pubPagina + 1) * 100 >= publicaciones.length}
                    onClick={() => setPubPagina(pubPagina + 1)}
                  >
                    Siguiente
                  </Button>
                </div>
              ) : null}
              {!publicaciones.length ? (
                <div style={{ fontSize: 13, color: "#94a3b8" }}>
                  No hay publicaciones con ese filtro. Para leerlas: boton <i class="fas fa-sync"></i> de la cuenta en la pestana Cuentas.
                </div>
              ) : null}
              <div style={{ fontSize: 12, color: "#64748b", marginTop: 6 }}>
                Precio, stock, pausar y SKU solo aparecen en cuentas en modo "Lectura y escritura". Todo cambio queda en "Cambios en Meli".
              </div>
            </>
          ) : null}

          {pestana === "existencias" ? (
            <ExistenciasMeli URL={URL} headers={headers} cuentas={cuentas} areas={areas} recargaCuentas={cargaCuentas} error={error} />
          ) : null}

          {pestana === "full" ? <FullMeli URL={URL} headers={headers} cuentas={cuentas} areas={areas} error={error} /> : null}

          {pestana === "cambios" ? <CambiosMeli URL={URL} headers={headers} cuentas={cuentas} error={error} /> : null}

          {pestana === "ventas" ? (
            <>
              <div style={{ display: "flex", gap: 10, marginBottom: 10, flexWrap: "wrap" }}>
                <Input bsSize="sm" type="select" value={filtroCuenta} onChange={(e) => setFiltroCuenta(e.target.value)} style={{ width: 200 }}>
                  <option value="">Todas las cuentas</option>
                  {cuentas
                    .filter((c) => c.plataforma === "Mercado Libre")
                    .map((c) => (
                      <option key={c._id} value={c._id}>
                        {c.nombre}
                      </option>
                    ))}
                </Input>
                <Input bsSize="sm" type="select" value={filtroEstado} onChange={(e) => setFiltroEstado(e.target.value)} style={{ width: 220 }}>
                  <option value="">Todos los estados</option>
                  {["Registrada", "Sin casar", "Cancelada", "Devuelta", "Cancelada sin registrar", "Error"].map((x) => (
                    <option key={x} value={x}>
                      {x}
                    </option>
                  ))}
                </Input>
                <span style={{ fontSize: 12, color: "#64748b", alignSelf: "center" }}>
                  {ventas.length} renglones · "Sin casar" se reintenta en cada corte cuando el SKU ya exista en el catalogo
                </span>
              </div>
              <Table size="sm" striped borderless className="table-responsive-xl">
                <thead>
                  <tr>
                    <th>Cuenta</th>
                    <th>Orden</th>
                    <th>Fecha</th>
                    <th>SKU</th>
                    <th>Articulo</th>
                    <th>Logistica</th>
                    <th className="text-right">Pzs</th>
                    <th className="text-right">Precio bruto</th>
                    <th className="text-right">Neto</th>
                    <th>Estado</th>
                    <th>Surtido / Devol.</th>
                  </tr>
                </thead>
                <tbody>
                  {ventas.map((v) => (
                    <tr key={v._id}>
                      <td>{v.cuentas && v.cuentas.nombre}</td>
                      <td style={{ fontSize: 12 }}>{v.orderId}</td>
                      <td style={{ fontSize: 12 }}>{v.fechaVenta}</td>
                      <td style={{ fontSize: 12 }}>{v.sku || <span style={{ color: "#94a3b8" }}>sin SKU</span>}</td>
                      <td style={{ fontSize: 12 }}>{v.articulos ? v.articulos.nombre : v.titulo}</td>
                      <td style={{ fontSize: 12 }}>{v.logistica === "fulfillment" ? "Full" : v.logistica || "—"}</td>
                      <td className="text-right">{v.cantidad}</td>
                      <td className="text-right">${Number(v.precioBruto || 0).toLocaleString("en-US")}</td>
                      <td className="text-right">${Number(v.precio || 0).toLocaleString("en-US")}</td>
                      <td>
                        <Badge
                          pill
                          title={v.mensaje}
                          color={
                            v.estado === "Registrada"
                              ? "success"
                              : v.estado === "Sin casar" || v.estado === "Error"
                              ? "danger"
                              : v.estado === "Cancelada sin registrar"
                              ? "secondary"
                              : "warning"
                          }
                        >
                          {v.estado}
                        </Badge>
                        {v.mensaje ? <div style={{ fontSize: 10, color: "#b91c1c" }}>{v.mensaje}</div> : null}
                      </td>
                      <td style={{ fontSize: 12 }}>
                        {v.surtidos ? `Surtido ${v.surtidos.idSurtido}` : v.pedidos ? `Pedido ${v.pedidos.idPedido}` : ""}
                        {v.devoluciones ? ` · Devol. ${v.devoluciones.idDevolucion}` : ""}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          ) : null}

          {pestana === "bitacora" ? (
            <Table size="sm" striped borderless className="table-responsive-xl">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Cuenta</th>
                  <th>Tipo</th>
                  <th>Estado</th>
                  <th>Mensaje</th>
                  <th>Referencia</th>
                </tr>
              </thead>
              <tbody>
                {bitacora.map((b) => (
                  <tr key={b._id}>
                    <td style={{ fontSize: 12 }}>{String(b.createdAt).slice(0, 16).replace("T", " ")}</td>
                    <td>{b.cuentas?.[0]?.nombre || "—"}</td>
                    <td>{b.tipo}</td>
                    <td>
                      <Badge color={b.estado === "OK" ? "success" : b.estado === "Error" ? "danger" : "info"} pill>
                        {b.estado}
                      </Badge>
                    </td>
                    <td style={{ fontSize: 12 }}>{b.mensaje}</td>
                    <td style={{ fontSize: 11, color: "#64748b" }}>{b.referencia}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          ) : null}
        </div>
      </div>
    </>
  );
}

export default Integraciones;
